import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/pluck';
import { ActivatedRoute } from '@angular/router';

import { Tracker, BreadcrumbItem } from '../../../entities/index';
import { TrackerB2bService } from '../../../services/tracker-b2b.service';
import { ListComponent } from '../list.component';
import { Log } from '../../../utils/index';

@Component({
  selector: 'app-tracker-b2b-list',
  templateUrl: './tracker-b2b-list.html'
})
export class TrackerB2bListComponent extends ListComponent implements OnInit {
  total$: Observable<number>;
  items$: Observable<Tracker[]>;

  pageTitle = 'Tracker B2B List';
  breadcrumbs: BreadcrumbItem[] = [
    new BreadcrumbItem('Tracker B2B List', 'map-marker')
  ];

  constructor(protected route: ActivatedRoute, protected trackerB2bService: TrackerB2bService) {
    super(route, trackerB2bService);
  }

  @Log()
  ngOnInit() {
    const source = this.createSource();
    this.total$ = source.pluck('total');
    this.items$ = source.pluck('items');
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/pages/tracker/tracker-b2b-list.component.ts